export default {
  pageTitle: '参与促销的商品',
  radio1: '待审核',
  radio2: '已通过',
  radio3: '已拒绝',
  radio4: '已取消',
  time1: '报名时间',
  typeEvent: 'Type of Event',
  placeholder1: '活动ID',
  placeholder2: 'Listing ID',
  placeholder3: 'Product Name',
  typeList1: '所有',
  typeList2: '满减',
  statusDisplaylist1: '待审核',
  statusDisplaylist2: 'Not yet started',
  statusDisplaylist3: 'Processing',
  statusDisplaylist4: '已过期',
  statusDisplaylist5: '取消或拒绝',
  statuslist1: '待审核',
  statuslist2: '已通过',
  statuslist3: '已拒绝',
  statuslist4: '已取消',
  columns1: 'ID',
  columns2: 'Listing ID',
  columns3: 'Product Name',
  columns4: 'Price Range',
  columns5: 'Enrollment status',
  columns6: 'Event ID',
  columns7: 'Event name',
  columns8: 'Creation time',
  columns9: 'Type of Event',
  columns10: 'Promotional content',
  columns11: 'Active status',
  columns12: 'Products applied',
  columns13: 'Detail',
  confirmContent: 'Are you sure you want to cancel?'
}
